
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-sale/details/[listingId]",
      function () {
        return require("private-next-pages/for-sale/details/[listingId].tsx");
      }
    ]);
  